/**
 * @module interface
 */
export interface V2TimFriendOperationResult {
    userID?: string;
    resultCode?: number;
    resultInfo?: string;
}
